import React, { useState, useEffect, useRef } from 'react'

import styles from './product.module.scss'
import { Link, useHistory } from 'react-router-dom'
import { ROUTES, PERMISSIONS, STATUS_PRODUCT, IMAGE_DEFAULT, ACTION } from 'consts'
import { compareCustom, formatCash, generatorTreeNodeCategories, tableSum } from 'utils'
import moment from 'moment'
import { compare } from 'utils'
import { useDispatch } from 'react-redux'

import {
  Switch,
  Slider,
  notification,
  Button,
  Modal,
  Table,
  Input,
  Row,
  Col,
  Space,
  Popconfirm,
  TreeSelect,
  Tag,
} from 'antd'

//components
import SettingColumns from 'components/setting-columns'
import columnsProduct from './columns'
import ExportProduct from 'components/ExportCSV/ExportProduct'
import ImportProducts from 'components/import-products'
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'
import FilterRegion from 'components/filter-region'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//apis
import { getCategories } from 'apis/category'
import { getProducts, updateProduct, deleteProduct } from 'apis/product'

export default function Product() {
  const dispatch = useDispatch()
  const history = useHistory()
  const typingTimeoutRef = useRef(null)
  const KEY_FILTER = 'productFilter'
  const filters = localStorage.getItem(KEY_FILTER) && JSON.parse(localStorage.getItem(KEY_FILTER))

  const [loading, setLoading] = useState(true)
  const [valueSearch, setValueSearch] = useState(filters ? filters.name || '' : '')
  const [paramsFilter, setParamsFilter] = useState(
    filters ? { ...filters } : { page: 1, page_size: 20 }
  )
  const [products, setProducts] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [categories, setCategories] = useState([])
  const [columns, setColumns] = useState([])
  const [countProduct, setCountProduct] = useState(0)

  const _getCategories = async () => {
    try {
      const res = await getCategories({ page: 1, page_size: 200, parent: true })
      if (res.status === 200)
        setCategories(res.data.data.map((e) => generatorTreeNodeCategories(e)))
    } catch (error) {
      console.log(error)
    }
  }

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys)
  }

  const ModalViewBulkPrices = ({ bulkPrices }) => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    const columns = [
      {
        title: 'STT',
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Số lượng thấp nhất',
        render: (text, record) => formatCash(record.min_quantity_apply || 0),
      },
      {
        title: 'Số lượng cao nhất',
        render: (text, record) => formatCash(record.max_quantity_apply || 0),
      },
      {
        title: 'Giá áp dụng',
        render: (text, record) => formatCash(record.price || 0),
      },
    ]

    return (
      <>
        <a onClick={toggle}>Xem giá sỉ</a>
        <Modal
          width="50%"
          title="Danh sách giá sỉ"
          footer={null}
          visible={visible}
          onCancel={toggle}
        >
          <Table
            scroll={{ y: '50vh' }}
            size="small"
            pagination={false}
            columns={columns}
            dataSource={bulkPrices}
          />
        </Modal>
      </>
    )
  }

  const columnsVariant = [
    {
      title: 'Hình ảnh',
      key: 'image',
    },
    {
      title: 'Mã thuộc tính',
      dataIndex: 'sku',
    },
    {
      title: 'Tên thuộc tính',
      dataIndex: 'title',
    },
    // {
    //   title: 'Giá bán sỉ',
    //   render: (text, record) =>
    //     record.prices && record.prices.length ? (
    //       <ModalViewBulkPrices bulkPrices={record.prices || []} />
    //     ) : (
    //       ''
    //     ),
    // },
    {
      title: 'Giá bán',
      render: (text, record) =>
        record.prices && record.prices.length ? formatCash(record.prices[0].price || 0) : 0,
    },
    {
      title: 'Hiển thị',
      key: 'is_active_variant',
    },
  ]

  const onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value

      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 750)
  }

  const _getProductsToExport = async () => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await getProducts({ store: true, is_souvenir: false })
      if (res.status === 200) {
        dispatch({ type: ACTION.LOADING, data: false })
        return res.data.data
      }
      dispatch({ type: ACTION.LOADING, data: false })
      return []
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
      return []
    }
  }

  const getAllProduct = async () => {
    setLoading(true)
    setProducts([])

    try {
      const res = await getProducts({ ...paramsFilter, store: true, is_souvenir: false })
      if (res.status === 200) {
        setProducts(
          res.data.data.map((e) => ({
            ...e,
            image: e.variants.length ? e.variants[0].image : [],
            price: e.variants.length ? e.variants[0].price : 0,
            price_no_tax: e.variants.length ? e.variants[0].price_no_tax : 0,
          }))
        )
        setCountProduct(res.data.count)
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const UpdateCategoryProducts = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)
    const [categoryIds, setCategoryIds] = useState([])

    useEffect(() => {
      if (!visible) setCategoryIds([])
    }, [visible])

    return (
      <>
        <Button size="large" onClick={toggle} type="primary">
          Cập nhật phân loại món
        </Button>
        <Modal
          title="Cập nhật phân loại món"
          centered
          width={500}
          footer={null}
          visible={visible}
          onCancel={toggle}
        >
          <TreeSelect
            multiple
            allowClear
            treeDefaultExpandAll
            size="large"
            style={{ width: '100%', marginBottom: 30 }}
            placeholder="Chọn phân loại món"
            treeNodeFilterProp="title"
            onChange={setCategoryIds}
            value={categoryIds}
            treeData={categories}
          />
          <Row justify="end">
            <Button
              onClick={async () => {
                try {
                  setLoading(true)

                  const listPromise = selectedRowKeys.map(async (product_id) => {
                    const res = await updateProduct({ category_ids: categoryIds }, product_id)
                    return res
                  })

                  await Promise.all(listPromise)
                  setLoading(false)
                  toggle()
                  await getAllProduct()
                  notification.success({
                    message: `Cập nhật thành công phân loại món vào các món ăn thành công!`,
                  })
                } catch (error) {
                  setLoading(false)
                  toggle()
                  console.log(error)
                }
              }}
              type="primary"
              size="large"
              disabled={categoryIds.length !== 0 ? false : true}
            >
              Cập nhật
            </Button>
          </Row>
        </Modal>
      </>
    )
  }

  const _deleteProduct = async (id) => {
    try {
      setLoading(true)
      const res = await deleteProduct([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xoá món ăn thành công!' })
          getAllProduct()
        } else
          notification.error({
            message: res.data.message || 'Xoá món ăn thất bại, vui lòng thử lại!',
          })
      } else
        notification.error({
          message: res.data.message || 'Xoá món ăn thất bại, vui lòng thử lại!',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  /*image product */
  const ContentZoomImage = (data) => {
    const [valueBox, setValueBox] = useState(300)
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <img
          src={data}
          style={{ width: valueBox, height: valueBox, objectFit: 'contain' }}
          alt=""
          onClick={(e) => e.stopPropagation()}
        />
        <Slider
          defaultValue={300}
          min={100}
          max={1000}
          onChange={(value) => setValueBox(value)}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    )
  }

  const _updateProduct = async (body, id) => {
    try {
      setLoading(true)
      let res = await updateProduct(body, id)
      setLoading(false)

      if (res.status === 200) notification.success({ message: 'Cập nhật thành công!' })
      else notification.error({ message: 'Cập nhật thất bại, vui lòng thử lại!' })

      getAllProduct()
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const onChangeCategoryValue = async (id) => {
    if (id && id.length) paramsFilter.category_id = id.join('---')
    else delete paramsFilter.category_id
    setParamsFilter({ ...paramsFilter, page: 1 })
  }

  const saveFiltersToLocalStorage = () => {
    const PARAMS_FILTER_DATE = [
      'from_date',
      'to_date',
      'today',
      'yesterday',
      'this_week',
      'last_week',
      'last_month',
      'this_month',
      'this_year',
      'last_year',
    ]

    const paramsFilterStorage = { ...paramsFilter }

    const keysParamsFilter = Object.keys(paramsFilterStorage)
    for (let i = 0; i < keysParamsFilter.length; i++)
      if (PARAMS_FILTER_DATE.includes(keysParamsFilter[i]))
        delete paramsFilterStorage[keysParamsFilter[i]]

    //save filters to localStorage
    localStorage.setItem(KEY_FILTER, JSON.stringify({ ...paramsFilterStorage }))
  }

  useEffect(() => {
    if (history.location.state) {
      if (history.location.state.filter && history.location.state.filter.name)
        setValueSearch(history.location.state.filter.name)
    }
  }, [])

  useEffect(() => {
    getAllProduct()
    saveFiltersToLocalStorage()
  }, [paramsFilter])

  useEffect(() => {
    _getCategories()
  }, [])

  return (
    <>
      <div className={`${styles['promotion_manager']} ${styles['card']}`}>
        <TitlePage title="Danh sách món ăn">
          <Space>
            <SettingColumns
              columns={columns}
              setColumns={setColumns}
              columnsDefault={columnsProduct}
              nameColumn="columnsProductStore"
            />
            <ImportProducts reload={() => getAllProduct()} />
            <ExportProduct
              fileName="Danh sách món ăn"
              name="Export món ăn"
              getProductsExport={_getProductsToExport}
            />
            <Link to={{ pathname: ROUTES.PRODUCT_ADD, description: 'món ăn' }}>
              <Button size="large" type="primary" icon={<PlusCircleOutlined />}>
                Thêm món ăn
              </Button>
            </Link>
          </Space>
        </TitlePage>

        <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={24} lg={10} xl={10}>
            <Input
              size="large"
              style={{ width: '100%' }}
              name="name"
              value={valueSearch}
              onChange={onSearch}
              className={styles['orders_manager_content_row_col_search']}
              placeholder="Tìm kiếm theo tên món ăn"
              allowClear
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={7} xl={7}>
            <TreeSelect
              size="large"
              style={{ width: '100%', userSelect: 'unset', display: 'block' }}
              listHeight={200}
              placeholder="Tìm kiếm theo phân loại món"
              allowClear
              multiple
              treeData={categories}
              treeNodeFilterProp="title"
              treeDefaultExpandAll
              value={
                paramsFilter.category_id ? paramsFilter.category_id.split('---').map((e) => +e) : []
              }
              onChange={onChangeCategoryValue}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={7} xl={7}>
            <div style={{ width: '100%' }}>
              <FilterDate
                size="large"
                paramsFilter={paramsFilter}
                setParamsFilter={setParamsFilter}
              />
            </div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
          <Col xs={24} sm={24} md={24} lg={10} xl={10}>
            <FilterRegion
              width_size={'100%'}
              setParamsFilter={setParamsFilter}
              paramsFilter={paramsFilter}
              title="product"
            />
          </Col>
        </Row>

        <Row
          justify="space-between"
          wrap={false}
          style={{ marginTop: 20, marginBottom: 10, width: '100%' }}
        >
          <Space size="middle" style={{ visibility: !selectedRowKeys.length && 'hidden' }}>
            <UpdateCategoryProducts />
          </Space>
        </Row>

        <div className={styles['view_product_table']}>
          <Table
            style={{ width: '100%' }}
            rowSelection={{
              selectedRowKeys,
              onChange: onSelectChange,
            }}
            rowKey="product_id"
            expandable={{
              expandedRowRender: (record) => {
                return (
                  <div style={{ marginTop: 25, marginBottom: 25 }}>
                    <Table
                      style={{ width: '100%' }}
                      pagination={false}
                      columns={columnsVariant.map((column) => {
                        if (column.key === 'image')
                          return {
                            ...column,
                            render: (text, variant) => (
                              <img
                                style={{ width: 80, height: 80 }}
                                src={
                                  variant.image_urls.length
                                    ? variant.image_urls[0] || IMAGE_DEFAULT
                                    : IMAGE_DEFAULT
                                }
                                alt=""
                              />
                            ),

                            // render: (text, variant) => (
                            //   <ImagesVariant record={variant} product={record} />
                            // ),
                          }
                        if (column.key === 'is_active_variant')
                          return {
                            ...column,
                            render: (text, variant) => (
                              <Switch
                                checked={variant.is_active}
                                onChange={(checked) => {
                                  const variantIndex = record.variants.findIndex(
                                    (v) => v.variant_id === variant.variant_id
                                  )

                                  if (variantIndex !== -1) {
                                    const variants = record.variants
                                    variants[variantIndex].is_active = checked
                                    _updateProduct({ variants: variants }, record.product_id)
                                  }
                                }}
                              />
                            ),

                            // render: (text, variant) => (
                            //   <ImagesVariant record={variant} product={record} />
                            // ),
                          }

                        // if (column.key === 'enable_bulk_price')
                        //   return {
                        //     ...column,
                        //     render: (text, variant) => (
                        //       <Switch
                        //         checked={variant.enable_bulk_price}
                        //         onChange={(checked) =>
                        //           enableBulkPrice(record, { ...variant, enable_bulk_price: checked })
                        //         }
                        //       />
                        //     ),
                        //   }

                        return column
                      })}
                      dataSource={record.variants}
                      size="small"
                    />
                  </div>
                )
              },
              expandedRowKeys: selectedRowKeys,
              expandIconColumnIndex: -1,
            }}
            columns={columns.map((column) => {
              if (column.key === 'stt')
                return {
                  ...column,
                  render: (text, record, index) =>
                    (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
                }

              if (column.key === 'name-product')
                return {
                  ...column,
                  render: (text, record) => (
                    <Link
                      to={{ pathname: ROUTES.PRODUCT_UPDATE, state: record, description: 'món ăn' }}
                    >
                      {text}
                    </Link>
                  ),
                  sorter: (a, b) => compare(a, b, 'name'),
                }

              if (column.key === 'image')
                return {
                  ...column,
                  render: (text, record) => (
                    <img
                      style={{ width: 80, height: 80 }}
                      src={record.image_urls.length ? record.image_urls[0] : IMAGE_DEFAULT}
                      alt=""
                    />
                  ),
                }

              if (column.key === 'category')
                return {
                  ...column,
                  render: (text, record) =>
                    record.category_info && (
                      <Space wrap={true}>
                        {record.category_info.map((category, index) => (
                          <Tag key={index} closable={false}>
                            {category.name}
                          </Tag>
                        ))}
                      </Space>
                    ),
                }
              if (column.key === 'create_date')
                return {
                  ...column,
                  sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
                  render: (text, record) =>
                    record.create_date && moment(record.create_date).format('DD-MM-YYYY HH:mm'),
                }

              if (column.key === 'active')
                return {
                  ...column,
                  render: (text, record) => (
                    <Switch
                      defaultChecked={record.is_active}
                      onClick={() =>
                        _updateProduct({ is_active: !record.is_active }, record.product_id)
                      }
                    />
                  ),
                }

              if (column.key === 'action')
                return {
                  ...column,
                  render: (text, record) => (
                    <Popconfirm
                      title="Bạn có muốn xoá món ăn này không?"
                      okText="Đồng ý"
                      cancelText="Từ chối"
                      onConfirm={() => _deleteProduct(record.product_id)}
                    >
                      <DeleteOutlined style={{ color: 'red', fontSize: 18, cursor: 'pointer' }} />
                    </Popconfirm>
                  ),
                }

              return column
            })}
            loading={loading}
            dataSource={products}
            size="small"
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countProduct,
            }}
          />
        </div>
      </div>
    </>
  )
}
